import { useLayoutEffect } from "react"
import { DraftProjectForm } from "./DraftProjectForm"

export const CreateProject = () => {
    useLayoutEffect(() => {
        document.title = 'Создание проекта'
    }, [])

    return <DraftProjectForm/> 
}
